import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetPollsForObject } from '../../Hooks/usePollHooks';
import PollDisplay from './PollDisplay';
import './PollList.scss';
import { ObjectType } from '../../Types/base';

interface PollListProps {
	objectType: ObjectType;
	objectId: number;
	readonly?: boolean;
}

const PollList = ({ objectType, objectId, readonly = false }: PollListProps) => {
	const { t } = useTranslation();
	const { polls, statusState } = useGetPollsForObject(objectType, objectId);

	useEffect(() => {
		console.log('PollList loaded', { objectType, objectId, polls });
	}, [objectType, objectId, polls]);

	if (statusState === 'LOADING') {
		return (
			<div className='biz-poll-list'>
				<div className='loading'>{t('POLL_LIST.LOADING')}</div>
			</div>
		);
	}

	if (statusState === 'ERROR') {
		return (
			<div className='biz-poll-list'>
				<div className='error'>{t('POLL_LIST.ERROR_LOADING')}</div>
			</div>
		);
	}

	if (!polls || polls.length === 0) {
		return (
			<div className='biz-poll-list'>
				<div className='no-polls'>{t('POLL_LIST.NO_POLLS_AVAILABLE')}</div>
			</div>
		);
	}

	return (
		<div className='biz-poll-list'>
			{polls.map((poll) => (
				<PollDisplay key={poll.Id} poll={poll} readonly={readonly} />
			))}
		</div>
	);
};

export default PollList;